import React from 'react'

import TaskForm from './TaskForm'
import { TASK_LIST } from '../urls'
import { usePostRequest } from '../hooks/request'

export default function EmployeeCreate({ onCancel, onSuccess }) {
    const taskCreate = usePostRequest({ url: TASK_LIST })

    async function onSubmit(data, actions) {
        await taskCreate.request({
            data: {
                ...data,
                dueTime: data.dueTime ? data.dueTime : null,
            },
        })
        actions.resetForm()
        onSuccess()
    }

    return (
        <div>
            <b>Янги топшириқ қўшинг</b><br /><br />

            <TaskForm
                loading={taskCreate.loading}
                onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
